import './assets/main.css'
import 'vant/lib/index.css'
import "./assets/style/common.scss";
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { initRem } from '@/utils/rem';
// 1. 引入 Element Plus的tree
import Vant from 'vant'
import 'vant/lib/index.css'; // 引入 Vant 4 完整样式（必须）
import FetchInterceptor from './utils/fetch-interceptor'

import App from './App.vue'
import router from './router'
initRem(); // 设置手机端字体

// 初始化 fetch 拦截器
FetchInterceptor.init()
const app = createApp(App)

// 确保Vue Devtools在开发环境中启用
// if (import.meta.env.DEV) {
//   app.config.performance = true
// }

app.use(createPinia())
app.use(router)
app.use(Vant)

app.mount('#app')
